(function () {
  'use strict';

  // ── mobile drawer ────────────────────────────────────────────
  var toggle = document.querySelector('[data-drawer-toggle]');
  var drawer = document.querySelector('[data-drawer]');
  if (toggle && drawer) {
    toggle.addEventListener('click', function () {
      var open = drawer.getAttribute('data-open') === 'true';
      drawer.setAttribute('data-open', String(!open));
      toggle.setAttribute('aria-expanded', String(!open));
    });
  }

  // ── slideshows (hero strip + product gallery) ────────────────
  document.querySelectorAll('[data-slides]').forEach(function (strip) {
    var slides = [].slice.call(strip.querySelectorAll('.strip__slide'));
    var dots = [].slice.call(strip.querySelectorAll('.strip__dot'));
    if (slides.length < 2) return;
    var i = 0;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.setAttribute('data-active', String(k === i)); });
      dots.forEach(function (d, k) { d.setAttribute('data-active', String(k === i)); });
    }
    var prev = strip.querySelector('[data-prev]');
    var next = strip.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { show(i - 1); });
    if (next) next.addEventListener('click', function () { show(i + 1); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); }); });
    var x = null;
    strip.addEventListener('touchstart', function (e) { x = e.changedTouches[0].clientX; }, { passive: true });
    strip.addEventListener('touchend', function (e) {
      if (x === null) return;
      var dx = e.changedTouches[0].clientX - x;
      if (Math.abs(dx) > 40) show(dx < 0 ? i + 1 : i - 1);
      x = null;
    }, { passive: true });
  });

  // ── variant picker ───────────────────────────────────────────
  document.querySelectorAll('[data-variants]').forEach(function (root) {
    var data = {};
    try { data = JSON.parse(root.querySelector('[data-variant-json]').textContent); } catch (e) { return; }
    var idField = root.querySelector('[name="id"]');
    var priceEls = document.querySelectorAll('[data-variant-price]');
    var btns = [].slice.call(root.querySelectorAll('.variants__opt'));

    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.hasAttribute('disabled')) return;
        var v = data[b.getAttribute('data-variant-id')];
        btns.forEach(function (o) { o.setAttribute('aria-pressed', String(o === b)); });
        if (idField) idField.value = b.getAttribute('data-variant-id');
        priceEls.forEach(function (el) { if (v) el.innerHTML = v.price_html; });
      });
    });
  });

  // ── quantity steppers ────────────────────────────────────────
  document.querySelectorAll('.qty').forEach(function (q) {
    var input = q.querySelector('input');
    q.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var step = b.getAttribute('data-step') === 'up' ? 1 : -1;
        var n = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, n + step);
        if (input.form && input.form.hasAttribute('data-cart-update')) input.form.submit();
      });
    });
  });
})();
